<template>
<div>
<nav class="navbar is-primary is-fixed-top" role="navigation" aria-label="main navigation">
  <div class="navbar-brand">
    <router-link :to="{name:'home'}" class="logo">
      <img :src="`${$publicPath()}logo.jpg`" width="150"/>
    </router-link>

    <a role="button" class="navbar-burger burger" :class="{'is-active': burgerActive}"
      aria-label="menu" :aria-expanded="burgerActive"
      @click="burgerActive=!burgerActive">
      <span aria-hidden="true"></span>
      <span aria-hidden="true"></span>
      <span aria-hidden="true"></span>
    </a>
  </div>

  <div class="navbar-menu" :class="{'is-active': burgerActive}">
    <div class="navbar-start">
      <router-link @click.native="burgerActive = false" class="navbar-item" :to="{name: 'home'}">
        Home
      </router-link>

      <router-link @click.native="burgerActive = false" class="navbar-item"
        :to="{name: 'users', params: {type:'crew'}}">
        Crew Members
      </router-link>

      <router-link @click.native="burgerActive = false" class="navbar-item"
        :to="{name: 'users', params: {type:'on_dock'}}">
        Dock Services
      </router-link>

      <router-link @click.native="burgerActive = false" class="navbar-item"
        :to="{name: 'users', params: {type:'charterer'}}">
        Charterers
      </router-link>

      <router-link @click.native="burgerActive = false" class="navbar-item"
        :to="{name: 'users', params: {type:'diver'}}">
        Divers
      </router-link>

      <router-link @click.native="burgerActive = false" class="navbar-item"
        :to="{name: 'delivery'}">
        Delivery
      </router-link>

      <router-link @click.native="burgerActive = false" class="navbar-item" :to="{name: 'jobs'}">
        Advertisements
      </router-link>

      <template v-if="!isLoggedIn">
      </template>

      <template v-else>
      </template>
    </div>

    <div class="navbar-end">
      <div class="navbar-item">
        <div v-if="isLoggedIn" class="buttons">
          <button class="button is-primary" @click="logoutAndRedirect">
            Log out
          </button>
        </div>
        <div v-else>
          <router-link class="button is-light" :to="{name: 'login'}"
            @click.native="burgerActive = false">
            Log in
          </router-link>
        </div>
      </div>
    </div>
  </div>
</nav>
<div class="subheader">

  <template v-if="isLoggedIn">
    <router-link class="navbar-item" :to="{name: 'personal-info'}">
      Personal Info
    </router-link>
  </template>

  <router-link class="navbar-item" :to="{name: 'qualifications'}"
    v-if="isLoggedInOfTypes(['crew', 'diver', 'on_dock'])">
    Qualifications
  </router-link>

  <router-link class="navbar-item" :to="{name: 'skills'}" v-if="isLoggedIn">
    Skills
  </router-link>

  <router-link class="navbar-item" :to="{name: 'experience'}"
    v-if="isLoggedInOfTypes(['crew', 'diver', 'on_dock', 'charterer'])">
    Experience
  </router-link>
  <router-link class="navbar-item" :to="{name: 'certificates'}"
    v-if="isLoggedInOfTypes(['crew'])">
    Certificates
  </router-link>
  <router-link class="navbar-item" :to="{name: 'user-details', params: {id: user.id}}"
    v-if="isLoggedInOfTypes(['crew', 'on_dock', 'diver', 'owner', 'charterer'])">
    My Profile
  </router-link>

  <template v-if="isLoggedInOfTypes(['owner', 'charterer'])">
    <router-link class="navbar-item" :to="{name: 'my-jobs'}">
      My Jobs
    </router-link>
  </template>

  <template v-if="isLoggedIn">
    <router-link class="navbar-item" :to="{name: 'settings'}">
      Settings
    </router-link>
  </template>

</div>
</div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';

export default {
  data() {
    return {
      burgerActive: false,
    };
  },
  methods: {
    ...mapActions({
      logout: 'auth/logout',
    }),
    async logoutAndRedirect() {
      this.burgerActive = false;
      await this.logout();
      this.$router.replace({ name: 'login' });
    },
  },
  computed: {
    ...mapGetters({
      isLoggedInOfTypes: 'auth/isLoggedInOfTypes',
      isLoggedIn: 'auth/isLoggedIn',
      isLoggedInEmployer: 'auth/isLoggedInEmployer',
      isLoggedInEmployee: 'auth/isLoggedInEmployee',
    }),
    ...mapState({
      user: state => state.auth.user,
    }),
  },
};
</script>

<style lang="scss" scoped>
.navbar {
  border-bottom: 1px solid black;
}
.burger {
  color: black
}
.subheader {
  display: flex;
  flex-direction: row;
  max-width: 100%;
  flex-wrap: wrap;
}
.logo {
  display: flex;
  img {
    align-self: center;
    justify-self: center;
  }
}

</style>
